// extracted by mini-css-extract-plugin
module.exports = {"backLink":"back-link_backLink__2LGJM"};